import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;

  .ant-form-item {
    width: 288px;
  }

  & > div {
    margin-right: 48px;
  }
`;
